
import { colors } from './colors';

export function init({id}) {
  const parent = document.getElementById(id);

  const canvas = parent.querySelector('canvas');
  const sickValue = parent.querySelector('.sick-value');
  const infectedValue = parent.querySelector('.infected-value');
  const reproValue = parent.querySelector('.repro-value');
  const slider = parent.querySelector('input');

  const isEnglish = window.location.pathname.split('/').includes('english');

  const ratio = 2.16;
  let width = parent.offsetWidth;
  let height = width / ratio;
  const canvasWidth = 1300;
  const canvasHeight = 600;

  canvas.width = canvasWidth;
  canvas.height = canvasHeight;
  canvas.style.width = `${width}px`;
  canvas.style.height = `${height}px`;

  slider.min = '500';
  slider.max = '5000';
  slider.value = '3000';
  slider.addEventListener('input', redraw);

  const ctx = canvas.getContext('2d');

  redraw();

  function redraw() {
    const r0 = slider.value/1000;
    const incubationPeriod = 1/5.5;
    const infectionPeriod = 1/3;
    const pop = 83000000;

    const chartHeight = canvasHeight - 0;
    const chartWidth  = canvasWidth  - 0;

    reproValue.innerText = `${r0.toFixed(1)}`;

    const timeStep = 1/10;

    ctx.clearRect(0,0,canvasWidth,canvasHeight);

    let vE = 40000/pop;
    let vI = 10000/pop;
    let vR = 0;
    let vS = 1 - (vE+vI+vR);

    let maxIllx = 0;
    let maxIlly = 0;
    let maxIlls = 0;
    let x = 0;

    while ((x < canvasWidth) || (vE+vI > 1e-4)) {
      x++;

      const d0 = r0*infectionPeriod*vS*vI;
      const d1 = incubationPeriod*vE;
      const d2 = infectionPeriod*vI;

      vS += (  -d0)*timeStep;
      vE += (d0-d1)*timeStep;
      vI += (d1-d2)*timeStep;
      vR += (d2   )*timeStep;

      const s = vE+vI;
      if (s > maxIlls) {
        maxIlls = s;
        maxIllx = x;
      }

      if (x < canvasWidth) {
        ctx.fillStyle = colors.sick; // Sick
        ctx.fillRect(x,0,1,chartHeight);

        ctx.fillStyle = colors.cured; // Healthy
        ctx.fillRect(x,0,1,chartHeight*(vS+vR));

        ctx.fillStyle = colors.healthyArea; // Healthy
        ctx.fillRect(x,0,1,chartHeight*(vS));
      }
    }

    ctx.fillStyle = '#000';
    ctx.strokeStyle = '#000';
    ctx.lineWidth = 2;

    const h2 = Math.round(vS*chartHeight);
    const maxSickx = Math.round(canvasWidth-35);
    maxIlly = Math.round((1-maxIlls)*chartHeight);

    ctx.beginPath();
    ctx.moveTo(maxSickx, chartHeight-0.5);
    ctx.lineTo(maxSickx+20, chartHeight-0.5);
    ctx.moveTo(maxSickx, h2-0.5);
    ctx.lineTo(maxSickx+20, h2-0.5);
    ctx.moveTo(maxSickx+10.5, chartHeight-0.5);
    ctx.lineTo(maxSickx+10.5, h2-0.5);
    ctx.stroke();

    infectedValue.innerText = `${+(100*(1-vS)).toFixed(0)} %`;

    ctx.beginPath();
    ctx.moveTo(maxIllx-10, chartHeight-0.5);
    ctx.lineTo(maxIllx+10, chartHeight-0.5);
    ctx.moveTo(maxIllx-10, maxIlly-0.5);
    ctx.lineTo(maxIllx+10, maxIlly-0.5);
    ctx.moveTo(maxIllx+0.5, chartHeight-0.5);
    ctx.lineTo(maxIllx+0.5, maxIlly-0.5);
    ctx.stroke();

    sickValue.innerText = `${+(100*maxIlls).toFixed(0)} %`;

    ctx.textAlign = 'right';
    ctx.textBaseline = 'middle';
    ctx.font = '26px sans-serif';

    ctx.translate(chartWidth*0.8, canvasHeight-25);
    ctx.fillText(isEnglish ? 'time' : 'Zeitverlauf', 0, 0);
    addArrow();
    ctx.setTransform(1, 0, 0, 1, 0, 0);

    ctx.translate(30, chartHeight/2-90);
    ctx.rotate(-Math.PI/2);
    ctx.fillText(isEnglish ? 'share of population' : 'Bevölkerungsanteil', 0, 0);
    addArrow();
    ctx.setTransform(1, 0, 0, 1, 0, 0);

    function addArrow() {
      ctx.beginPath();
      ctx.moveTo(10, 0);
      ctx.lineTo(60, 0);
      ctx.moveTo(52, -5);
      ctx.lineTo(60, 0);
      ctx.lineTo(52, 5);
      ctx.stroke();
    }
  }

  function resize() {
    width = parent.offsetWidth;
    height = width / ratio;
    canvas.style.width = `${width}px`;
    canvas.style.height = `${height}px`;

    redraw();
  }

  return { resize };
}
